import React from "react"
import { ContentLink, QBankImage } from "../../@types/CapioWeb/core"
import {
	LinkProperty,
	StringProperty,
} from "../../@types/EpiFoundationSpa/Property"
import { BlockCommonLayout } from "../../utils/layout"
import { LatestNewsCard } from "./LatestNewsCard"

interface LatestNewsListItem {
	newsSubject: string
	newsDate: string
	newsHeader: string
	newsPageLink: ContentLink
}

interface CapioLatestNewsBlockProps {
	newsPages: LatestNewsListItem[]
	header: StringProperty
	imageBlock: QBankImage
	preamble: StringProperty
	ctaLink: LinkProperty
}

export const CapioLatestNewsBlock: React.FC<CapioLatestNewsBlockProps> = ({
	header,
	imageBlock,
	preamble,
	ctaLink,
	newsPages,
}) => {
	return (
		<BlockCommonLayout heading={header} description={preamble}>
			<LatestNewsCard
				cta={
					ctaLink?.href && {
						text: ctaLink?.text ?? "",
						href: ctaLink?.href ?? "",
					}
				}
				image={imageBlock}
				items={newsPages.slice(0, 4).map((item) => ({
					header: item.newsHeader,
					href: item.newsPageLink.url,
					text: item.newsSubject,
					date: item.newsDate,
				}))}
			/>
		</BlockCommonLayout>
	)
}
